// Who still needs a group.
//
// "Unassigned" used to mean one thing: no groupId. But some members tell the
// club they're sitting this term out and will pick things up next term, and
// those people are not a job to be done — leaving them in the unassigned pile
// means the pile never empties and stops meaning anything.
//
// `deferred: true` on a player marks that deliberate choice. The field is
// omitted rather than set to false, so members who have never been deferred
// stay byte-identical in kac_data.json.
//
// `noFit: true` marks the other reason a member sits outside a group on
// purpose: they want to play, but none of the clinics the club runs lands at
// a time they can make. Same effect on the unassigned pile — a coach can't
// place them into a slot that doesn't exist — but a different meaning, so it
// gets its own flag and its own Issues row: these are the people who would
// join if the schedule grew. The two reasons are mutually exclusive; setting
// either clears the other.

export function isDeferred(player) {
  return player?.deferred === true;
}

export function hasNoFit(player) {
  return player?.noFit === true;
}

// In no group, and not deliberately sitting outside one for either reason —
// the people a coach still has to find a place for. This is the definition
// behind the header count, the Issues entry and the roster's Unassigned
// section, so they can't drift apart.
export function needsPlacing(player) {
  return !player?.groupId && !isDeferred(player) && !hasNoFit(player);
}

export function countNeedingPlacement(players) {
  return (Array.isArray(players) ? players : []).filter(needsPlacing).length;
}

export function countDeferred(players) {
  return (Array.isArray(players) ? players : []).filter(isDeferred).length;
}

export function countNoFit(players) {
  return (Array.isArray(players) ? players : []).filter(hasNoFit).length;
}
